import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider, useI18n } from "./context/I18nContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import ImageToPdf from "./pages/ImageToPdf";
import CvBuilder from "./pages/CvBuilder";
import JobMatch from "./pages/JobMatch";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  return children;
}

function Shell() {
  const { lang } = useI18n();
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/tools/job-match" element={<Protected><JobMatch /></Protected>} />
        <Route path="/tools/image-to-pdf" element={<Protected><ImageToPdf /></Protected>} />
        <Route path="/tools/cv-builder" element={<Protected><CvBuilder /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace/>} />
      </Routes>
      <footer className="border-t border-[#E2DBCE] py-6 mt-10 text-center text-sm text-[#64748B]">
        <span className="font-serif-display italic">image to pdf + classic cv</span> · {lang === "ar" ? "مبني لدقة المستندات" : "Built for precision documents"} · © {new Date().getFullYear()}
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <Shell />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
